import * as IoC from 'typescript-ioc';
import { IApiClient } from '../../infrastructure/api-client';
import { IEventRequestParams } from '../shared.dto';
import {ICustomCssDAO, ICustomCssDTO} from '../custom-css.dao';

class CustomCssDAO extends ICustomCssDAO {
    static readonly customCssUrl: string = 'account/{accountId}/event/{eventId}/passport-custom-css';

    constructor(@IoC.Inject private readonly apiClient: IApiClient) {
        super();
    }

    public async getEventCustomCss(params: IEventRequestParams): Promise<ICustomCssDTO> {
        const response = await this.apiClient.get<ICustomCssDTO>(CustomCssDAO.customCssUrl, params);
        return response.parsedResponse;
    }

    public async updateEventCustomCss(params: IEventRequestParams & ICustomCssDTO): Promise<ICustomCssDTO> {
        const response = await this.apiClient.put<ICustomCssDTO>(CustomCssDAO.customCssUrl, params);
        return response.parsedResponse;
    }
}

export { CustomCssDAO };